import { LODGIN_TYPES } from '../../actions/classification';
import { pathSources } from '../../constants/common';
import { getAdditionalLocales } from '../../utils/LocaleMap';
import { isCountryInGoogleMapsExclusionList } from '../../utils/UserLocationUtil';
import reasons from '../ListYourPropertyPage/EligibilityCatch/reasons';

const hasLatLng = ({ latLng }) => latLng && latLng.lat && latLng.lng;
const hasNoLatLng = (state) => !hasLatLng(state);

const isUserLoggedIn = ({ isLoggedIn }) => isLoggedIn;
const isUserNotLoggedIn = ({ isLoggedIn }) => !isUserLoggedIn({ isLoggedIn });

const isOwner = ({ loggedInUserType }) => loggedInUserType === 'owner';
const isTraveler = ({ loggedInUserType }) => loggedInUserType === 'traveler';
const isMissingDetails = ({ hasPhoneNumber, hasPasswordSet }) => !hasPhoneNumber || !hasPasswordSet;
const isNotMissingDetails = (state) => !isMissingDetails(state);
const isMissingAdvertiser = ({ hasAdvertiserForSite }) => !hasAdvertiserForSite;

const isEg = ({ features }) => features.isConventionalLodgingFlow;
const isVrbo = ({ features }) => features.isFrboFlow;

const isAddressValid = ({ addressValidation }) => Object.keys(addressValidation).reduce(
    (acc, x) => acc && addressValidation[x].isValid,
    true
);
const isAddressInvalid = ({ addressValidation }) => {
    const result = !isAddressValid({ addressValidation });
    return result;
};

const isLodgingFlow = ({ classification }) => classification.lodgingPreference === LODGIN_TYPES.CL;
const isNotCAS = ({ isCasDeprecated }) => isCasDeprecated;
// eslint-disable-next-line max-len
const isInvalidByGeoCoder = ({ geocoderValidation }) => !geocoderValidation.value;

// eslint-disable-next-line max-len
const hasUnitNumberError = ({
    unitNumberValidation,
    unitCheckEnabled
}) => (!unitNumberValidation.value.unitNumberValid || unitNumberValidation.value.missingUnitNumber)
&& unitCheckEnabled;

const isClRejected = ({ eligibilityStatus }) => eligibilityStatus !== '';
const isTimeout = ({ eligibilityStatus }) => eligibilityStatus === reasons.TIMEOUT;
const isRedirectVrbo = ({ eligibilityStatus }) => eligibilityStatus === reasons.VRBO;
const isAAPRedirect = ({ eligibilityStatus }) => eligibilityStatus === reasons.ADD_PROPERTY;

const isLanguageSelection = ({ locale }) => {
    const urlParams = new URLSearchParams(window.location.search);
    const siteid = urlParams.get('siteId');
    const tpid = urlParams.get('tpid');
    const eapid = urlParams.get('eapid');
    const langid = urlParams.get('langId');
    const utmSource = urlParams.get('utm_source');
    const locales = getAdditionalLocales(siteid, tpid, eapid, langid, utmSource, locale.canonical);
    if (Array.isArray(locales) && locales.length >= 1) {
        return true;
    }
    return false;
};

// pathsource is not the default ULX one.
// eslint-disable-next-line max-len
const isExternalFlow = ({ pathSource }) => pathSource !== pathSources.ULX;

const isAAPV2 = ({ pathSource }) => pathSource === pathSources.addPropertyV2;

const isAddressV2Feature = ({ isAddressV2 }) => isAddressV2;

// eslint-disable-next-line max-len
const isUserLocationInGoogleMapsExclusionList = ({ userCountryCode }) => isCountryInGoogleMapsExclusionList(userCountryCode);

const isSelfServe = ({ isSelfServe: attr }) => attr;
const isNotSelfServe = ({ isSelfServe: attr }) => !attr;

const isTimeoutJel = ({ eligibilityStatus }) => eligibilityStatus === reasons.TIMEOUT_JEL;

const isEstimatePageRemoved = (
    { isEstimatePageRemoved: featureEnabled }
) => featureEnabled;

const isAgenticOnboardingProperty = (
    { isAgenticOnboardingProperty: featureEnabled }
) => featureEnabled;

const isVrboUplEnabled = ({ isVrboUpl: featureEnabled }) => featureEnabled;

const isArx = ({ isArxRedirect: featureEnabled }) => featureEnabled;

const isSharedSpaceDeflection = ({ isSharedSpaceDeflection: featureEnabled }) => featureEnabled;

export {
    isArx,
    isSharedSpaceDeflection,
    isVrboUplEnabled,
    isNotSelfServe,
    isEstimatePageRemoved,
    isAgenticOnboardingProperty,
    isTimeoutJel,
    isSelfServe,
    isAddressV2Feature,
    isInvalidByGeoCoder,
    hasUnitNumberError,
    hasLatLng,
    hasNoLatLng,
    isUserLoggedIn,
    isUserNotLoggedIn,
    isOwner,
    isTraveler,
    isMissingDetails,
    isNotMissingDetails,
    isMissingAdvertiser,
    isEg,
    isVrbo,
    isAddressValid,
    isAddressInvalid,
    isLodgingFlow,
    isLanguageSelection,
    isNotCAS,
    isClRejected,
    isExternalFlow,
    isUserLocationInGoogleMapsExclusionList,
    isAAPV2,
    isTimeout,
    isRedirectVrbo,
    isAAPRedirect
};
